import Vue from 'vue';
import moment from 'moment';

Vue.filter('moment', (value, format) => {
    return moment(value).format(format);
});
